import React from "react";
import ReactDOM from "react-dom";
import { sortable } from "react-sortable";

class SortableMenuItem extends React.Component {
  render() {
    return <div {...this.props}>{this.props.children}</div>;
  }
}

export var SortableItem = sortable(SortableMenuItem);
